var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "embedded-designer" },
    [
      _vm.visible
        ? _c("TemplateDesignerV2", {
            ref: "templateDesigner",
            attrs: {
              billType: _vm.billType,
              billTypeName: _vm.billTypeName,
              billNo: _vm.billNo,
              templateId: _vm.templateId,
              billData: _vm.billData,
              embedded: true,
            },
            on: { close: _vm.onClose, saved: _vm.onSaved },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }